module.exports = __webpack_public_path__ + "static/media/kr.d16ad565.svg";